import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { AdminAreaGate } from "../components/AdminAreaGate";
import { AccountsManager } from "../components/admin/accounts/AccountsManager";
import { AccountMenu } from "../components/AccountMenu";

const Shell = () => {
  const { user } = useAuth();
  return (
    <div data-testid="accounts-page" className="flex min-h-screen flex-col bg-background lg:h-screen lg:overflow-hidden">
      <header className="flex h-14 shrink-0 items-center gap-4 bg-[hsl(220_18%_11%)] px-4 text-[hsl(45_60%_96%)] lg:px-6">
        <Link to="/admin" data-testid="accounts-page-back" className="flex items-center gap-2 text-sm font-semibold text-white/80 hover:text-white">
          <ArrowLeft className="h-4 w-4" /> Admin
        </Link>
        <span className="font-heading text-lg font-extrabold tracking-tight">Accounts</span>
        {user.role === "staff" && <span data-testid="accounts-page-view-only" className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold">View only</span>}
        <AccountMenu testid="accounts-account-menu" variant="dark" className="ml-auto" />
      </header>
      <main className="min-h-0 flex-1 p-3 lg:p-4">
        <AccountsManager actorRole={user.role} />
      </main>
    </div>
  );
};

// /admin/accounts: the same list and account panel as the dashboard's Accounts tab; staff can look, admins change.
export default function AccountsPage() {
  return (
    <AdminAreaGate min="staff">
      <Shell />
    </AdminAreaGate>
  );
}
